import { render } from "./DocumentBrowser.vue?vue&type=template&id=78c1fc4e"
import script from "./DocumentBrowser.vue?vue&type=script&lang=js"
export * from "./DocumentBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__